// import classes from './AdminPortal.module.css'

const AdminPortal = () => {
  return (
    <h1 style={{color: "#ffffff"}}>Admin Portal</h1>
  )
};

export default AdminPortal;